import React from 'react';
import styles from '../base/CommonSettings.module.scss';
import { FaIcon } from '../../../common/Icons.jsx';
import icons from './flipCardIcons.js';
import LexicalEditor from '../../../common/richTextPlugins/LexicalEditor.lazy.jsx';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import DashboardImageUploadButton from '../../../common/ImageUploader/DashboardImageUploadButton.lazy.jsx';
import DashboardIconSelect from '../../../common/icon_select/DashboardIconSelect.lazy.jsx';
import DashboardColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';

function SettingsSide({widgetId, side = 'front'}) {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const cardColor = useSelector(state => state.dashboard.widgets[widgetId].settings[side]?.card_color);
  const textColor = useSelector(state => state.dashboard.widgets[widgetId].settings[side]?.text_color);
  const iconColor = useSelector(state => state.dashboard.widgets[widgetId].settings[side]?.icon_color);
  const sideContent = useSelector(state => state.dashboard.widgets[widgetId].settings[side]?.content);
  const iconType = useSelector(state => state.dashboard.widgets[widgetId].settings[side].icon_type);
  const attachment = useSelector(state => state.dashboard.widgets[widgetId].settings[side]?.attachment);

  const onChange = (editorState) => {
    setAttribute(`settings.${side}.content`, JSON.stringify(editorState));
  }

  return (
    <>
      <hr></hr>
      <CollapsibleSection title={I18n.t(`flip_card_${side}`)}>
        <div className={styles['settings-section']}>
          <div className={styles['settings-option']}>
            <LexicalEditor
              fieldname={`settings[${side}][content]`}
              value={sideContent}
              updateAnswer={(value) => setAttribute(`settings.${side}.content`, value)} // TODO fix not updating view live
              skeletonClassName={styles['option-two-cols']}
              editorContainerStyle={{width: '100%'}}
              onChange={onChange}
              simpleInput={true}
              />
          </div>
          <div className={styles['settings-option']}>
              <label>{I18n.t('select_upload_icon_prompt')}</label>
              <DashboardIconSelect
                options={icons}
                getOptionLabel={(e) => <FaIcon type={e.label} className='fa-xl' />}
                onChange={(value) => setAttribute(`settings.${side}.icon_type`, value)}
                value={iconType}
              />
              <DashboardImageUploadButton
                value={attachment}
                onChange={(val) => setAttribute(`settings.${side}.attachment`, val)}
              />
              <p className='description'>{I18n.t('predefined_image_primary_source_info')}</p>
          </div>
          <div className={styles['settings-option']}>
            <label>{I18n.t('flip_card_icon_color')}</label>
            <DashboardColorPicker value={iconColor} onChange={(val) => setAttribute(`settings.${side}.icon_color`,val)} />
            <p className='description'>{I18n.t('flip_card_icon_color_option_info')}</p>
          </div>
            <div className={styles['settings-option']}>
              <label>{I18n.t(`flip_card_card_color`)}</label>
              <DashboardColorPicker value={cardColor} onChange={(val) => setAttribute(`settings.${side}.card_color`,val)} />
            </div>
            <div className={styles['settings-option']}>
              <label>{I18n.t(`flip_card_text_color`)}</label>
              <DashboardColorPicker value={textColor} onChange={(val) => setAttribute(`settings.${side}.text_color`, val)} />
            </div>
        </div>
      </CollapsibleSection>
    </>
  );
};

const FLIP_BEHAVIORS = [
  {
    value: 'click',
    label: I18n.t('flip_on_click')
  },
  {
    value: 'hover',
    label: I18n.t('flip_on_hover')
  }
]

function FlipCardWidgetSettings({widgetId}) {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const flip_behavior = useSelector(state => state.dashboard.widgets[widgetId].settings?.flip_behavior) || 'click';
  return (
    <>
      {['front', 'back'].map(side => <SettingsSide key={side} widgetId={widgetId} side={side}/>)}
      <hr></hr>
      <CollapsibleSection title={I18n.t('interactions')}>
        <div className={styles['settings-option']}>
          <label>{I18n.t('flip_behavior')}</label>
          {
            FLIP_BEHAVIORS.map((f) => {
              return (
                <label className="font-weight-normal" key={f.value}>
                    <input
                        type="radio"
                        className="mr-1"
                        checked={flip_behavior === f.value}
                        onChange={(e) => setAttribute('settings.flip_behavior',f.value)}
                        value={f.value}
                    />
                    <span>{f.label}</span>
                </label>
                    )
            })
          }
        </div>
      </CollapsibleSection>
    </>
  )
}

export default FlipCardWidgetSettings;